import { render } from "./CreateProfileAccessDialog.vue?vue&type=template&id=2964341e&scoped=true"
import script from "./CreateProfileAccessDialog.vue?vue&type=script&lang=js"
export * from "./CreateProfileAccessDialog.vue?vue&type=script&lang=js"

import "./CreateProfileAccessDialog.vue?vue&type=style&index=0&id=2964341e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2964341e"]])

export default __exports__